import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

import { Container } from './layout';

export const ZoneIcon = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  line-height: 32px;
  border: 2px solid #fff;
  font-size: 13px;
  color: white;
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
`;

export const Ellipsis = styled.div`
  margin-left: 10px;
  font-size: 22px;
  &.small {
    font-size: 15px;
    margin-left: 5px;
  }
  /* top: 4px; */
`;

/**
 * page
 */
export const PageWrapper = styled(Container)`
  margin: auto;
  position: relative;
  margin-top: 25px;
`;

export const Headline = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  font-size: 26px;
  ${(props) =>
    props.$mb &&
    css`
      margin: 0 0 45px;
    `}
  ${(props) =>
    props.$alignLeft &&
    css`
      justify-content: flex-start;
    `}
`;

export const HeadLineWithMargin = styled(Headline)`
  margin-bottom: 35px;
`;

/**
 * card
 */
export const CardWrapper = styled(Container)`
  padding: 10px;
  background-color: #393e44;
  min-height: 100px;
  border-radius: 2px;
`;

export const Card = styled.div`
  border-radius: 2px;
`;

export const GeneralInfo = styled.div`
  position: relative;
  height: 170px;
  background-color: #262b31;
  padding: 20px 20px 0 20px;
  &.new-tariff {
    display: flex;
  }
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #393e44;
  min-height: 480px; //600
  padding: 25px 20px;
`;

export const DataWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #393e44;
  min-height: 480px; //600
  padding: 25px 20px;
`;

export const SectionLinksWrapper = styled.div`
  margin: 15px 0 0 0;
  min-height: 30px;
  &.double {
    display: flex;
    flex-wrap: wrap;
    > * {
      margin: 0 40px 0px 0;
    }
  }
`;

export const SectionLink = styled(NavLink)`
  margin: 0 30px 0 0;
  min-width: 30px;
  opacity: 0.6;
  font-size: 15px;
  color: #000000;
  padding: 0 0 8px 0;
  white-space: nowrap;
  &.active {
    opacity: 1;
    border-bottom: 4px solid #3ea5ff;
    color: #3ea5ff;
    font-weight: 900;
    font-size: 16px;
  }
`;

/**
 * windows
 */
export const Header = styled.h1`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #262b31;
`;

export const MainBlock = styled.div`
  font-size: 15px;
  color: #3e3e3e;
`;
